import { a as autoUpdate, c as computePosition, o as offset } from './floating-ui.dom-Lu2-1WW4.js';
import { c as createFocusTrap } from './focus-trap.esm-BUj_YYcQ.js';

class SizeSelector extends HTMLElement {
  cleanup;
  section = this.closest('section');
  sectionId = this.dataset.sectionId;
  form = this.section.querySelector('form');
  formButtons = this.form.querySelectorAll('button');
  reference = this.querySelector('[data-size-selector-reference]');
  dropdown = this.querySelector('[data-size-selector-dropdown]');
  inactiveClasses = ['opacity-0', 'invisible', '-translate-y-2'];

  connectedCallback() {
    this.initEvents();
    this.initFocusTrap();
  }

  /**
   * Initialize events
   */
  initEvents() {
    this.reference.addEventListener('click', (event) => {
      const { currentTarget } = event;
      currentTarget.ariaExpanded === 'true' ? this.close() : this.open();
    });
    window.addEventListener('scroll', () => this.close());
    this.dropdown.addEventListener('click', ({ target }) => {
      this.fetchSection(target.dataset.sizeValueId);
    });
  }

  /**
   * Initialize focus trap
   */
  initFocusTrap() {
    this.trap = createFocusTrap(this.dropdown, {
      clickOutsideDeactivates: true,
      onDeactivate: () => this.close(),
    });
  }

  /**
   * Open cart popover
   */
  open() {
    this.reference.ariaExpanded = 'true';
    this.dropdown.classList.remove(...this.inactiveClasses);

    // Wait for transition to complete before activating focus trap
    const handleTransitionEnd = () => {
      this.trap.activate();
      this.dropdown.removeEventListener('transitionend', handleTransitionEnd);
    };
    this.dropdown.addEventListener('transitionend', handleTransitionEnd);

    this.cleanup = autoUpdate(this.reference, this, () => {
      computePosition(this.reference, this.dropdown, {
        placement: 'bottom',
        middleware: [offset(8)],
      }).then(({ x, y }) => {
        Object.assign(this.dropdown.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    });
  }

  /**
   * Close cart popover
   */
  close() {
    if (!this.cleanup) return;
    this.reference.ariaExpanded = 'false';
    this.cleanup();
    if (this.trap.active) this.trap.deactivate();
    this.dropdown.classList.add(...this.inactiveClasses);
  }

  async fetchSection(valueId) {
    this.toggleLoading(true);

    try {
      const response = await fetch(
        `${window.location.pathname}?section_id=${this.sectionId}&option_values=${valueId}`
      );
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      this.replaceSection(html);
      this.replaceHistory(this.getVariantId(html));
    } catch (error) {
      console.error(error);
    } finally {
      this.toggleLoading(false);
    }
  }

  toggleLoading(loading) {
    this.formButtons.forEach((button) => {
      button.classList.toggle('button--loading', loading);
      button.disabled = loading;
    });
  }

  replaceSection(html) {
    console.log('Replacing section', html);
    const fetchedSection = html.querySelector(`#shopify-section-${this.sectionId}`);
    this.section.innerHTML = fetchedSection.innerHTML;
  }

  getVariantId(html) {
    const sizeSelector = html.querySelector('[data-size-selector]');
    console.log('Getting variant id', sizeSelector);
    return sizeSelector.dataset.variantId;
  }

  replaceHistory(variantId) {
    console.log('Replacing history', variantId);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    history.replaceState({}, '', url.toString());
  }
}

customElements.define('size-selector', SizeSelector);
